import { IonSpinner } from '@ionic/react';
import { cn } from '../../lib/utils';

interface MarkdownComposerActionsProps {
  onCancel: () => void;
  onSubmit: () => void;
  loading?: boolean;
  submitDisabled?: boolean;
  submitLabel?: string;
  cancelLabel?: string;
}

const ACTION_BASE_CLASSNAME = cn(
  'flex min-h-11 min-w-[8.5rem] items-center justify-center gap-2 border px-5 py-3 text-sm font-medium leading-none transition-colors',
  'focus:outline-none focus:ring-2 focus:ring-[var(--ion-color-primary)] focus:ring-offset-2',
  'disabled:cursor-not-allowed disabled:opacity-50'
);

const PRIMARY_ACTION_CLASSNAME =
  'border-[color:rgba(var(--ion-color-primary-rgb),0.2)] bg-[rgba(var(--ion-color-primary-rgb),0.08)] text-[var(--ion-color-primary-shade)] hover:bg-[rgba(var(--ion-color-primary-rgb),0.14)]';
const NEUTRAL_ACTION_CLASSNAME =
  'border-gray-300 bg-slate-50 text-slate-700 hover:border-slate-400 hover:bg-white';

export const MarkdownComposerActions = ({
  onCancel,
  onSubmit,
  loading = false,
  submitDisabled = false,
  submitLabel = 'Enviar',
  cancelLabel = 'Cancelar',
}: MarkdownComposerActionsProps) => {
  return (
    <div className="flex w-full items-center justify-between gap-2">
      <button
        type="button"
        onClick={onCancel}
        disabled={loading}
        className={cn(ACTION_BASE_CLASSNAME, NEUTRAL_ACTION_CLASSNAME)}
        style={{ borderRadius: '20px' }}
      >
        {cancelLabel}
      </button>
      <button
        type="button"
        onClick={onSubmit}
        disabled={loading || submitDisabled}
        className={cn(ACTION_BASE_CLASSNAME, PRIMARY_ACTION_CLASSNAME)}
        style={{ borderRadius: '20px' }}
      >
        {loading ? <IonSpinner name="crescent" /> : submitLabel}
      </button>
    </div>
  );
};
